import script from "./AdminTagView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminTagView.vue?vue&type=script&setup=true&lang=js"

import "./AdminTagView.vue?vue&type=style&index=0&id=749c2de1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-749c2de1"]])

export default __exports__